<template>
  <section class="section section--welcome" id="welcome">
    <ScrollDown
      :activeSection="activeSection"
      :isContactPanelActive="isContactPanelActive"
      :isMobile="isMobile"
      :isBackgroundPrimary="isBackgroundPrimary"
    />
    <aside class="left-panel"></aside>
    <main class="main" :class="!isBackgroundPrimary && isMobile ? 'main--white':''">
      <MobileNavBar
        v-if="isMobile"
        :isBackgroundPrimary="isBackgroundPrimary"
        :isMobileNavOpen="isMobileNavOpen"
        :isContactPanelActive="isContactPanelActive"
        :screenLevel="screenLevel"
        :class="!isBackgroundPrimary || screenLevel === 'bottom' ? 'mobile-navbar--white':''"
      />
      <LogoText v-if="isMobile" />
      <BottomText v-if="isMobile" />

      <Hooper :settings="sliderSettings" ref="carousel" @slide="updateCarousel">
        <Slide v-for="post in posts" :key="post.id" :index="post.id">
          <p class="upper-title">{{post.title}}</p>
          <h1 class="title title--big title--white" @click="showPost(post.id)">
            <span>{{post.subtitle}}</span>
          </h1>
          <div class="animation-box__wrapper">
            <img
              :src="require('@/assets/img/sprites/header/'+post.img)"
              alt
              class="animation-box__image"
              @load="imgLoaded"
            />
          </div>
        </Slide>
      </Hooper>

      <!-- <div class="animation-box__wrapper">
        <img
          src="../../assets/img/sprites/compressed/HP-01.png"
          alt
          class="animation-box__image"
          @load="imgLoaded"
        />
      </div>-->

      <div class="flex-container">
        <div class="line-dekor"></div>
        <div class="arrow__container">
          <img
            @click="slidePrev"
            class="arrow arrow--left"
            src="../../assets/img/arrow-left-hp.svg"
            alt="Arrow left"
          />
          <img
            class="arrow arrow--right"
            src="../../assets/img/arrow-right-hp.svg"
            alt="Arrow right"
            @click="slideNext"
          />
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import { bus } from "../../main";
import ScrollDown from "../ScrollDown.vue";
import MobileNavBar from "../mobile/MobileNavBar";
import BottomText from "../BottomText";
import LogoText from "../LogoText";

// header slider
import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";
import postsData from "../../singlePostsData";

// Mobile elements
// import MobileNavBar from "../mobile/MobileNavBar";

export default {
  name: "WelcomePage",
  components: {
    ScrollDown,
    MobileNavBar,
    BottomText,
    LogoText,
    Hooper,
    Slide,
  },
  props: {
    activeSection: Number,
    isContactPanelActive: Boolean,
    isMobile: Boolean,
    isMobileNavOpen: Boolean,
    isBackgroundPrimary: Boolean,
    screenLevel: String,
  },
  data() {
    return {
      sliderSettings: {
        autoPlay: true,
        infiniteScroll: true,
        playSpeed: 5000,
        transition: 1000,
        wheelControl: false,
      },
      sliderInfo: {
        activeSlide: null,
      },
      posts: postsData,
    };
  },
  methods: {
    showPost: function (postID) {
      bus.$emit("showPost", postID);
    },
    imgLoaded() {
      bus.$emit("hideLoader");
    },
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      this.$refs.carousel.slideNext();
    },
    updateCarousel(payload) {
      this.sliderInfo.activeSlide = payload.currentSlide;
    },
  },
  computed: {
    setClass: function () {
      return this.activeSection ? "active" : "";
    },
  },
};
</script>

<style lang="scss">
.section--welcome {
  .main.main {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    transition: 0.4s ease-in-out;
    padding: 0 !important;

    &--white {
      background-color: #fff !important;
    }

    .title {
      cursor: pointer;
      margin-bottom: 50px;
      // flex-grow: 1;
    }

    // slides elements animations
    .hooper-slide {
      @media (min-width: $tablet + 1) {
        &.is-active {
          .title,
          .upper-title {
            animation: slideInRight 1000ms 800ms ease-in-out both;
          }
          .animation-box__wrapper {
            animation: slideInSlide 1000ms 800ms ease-in-out both;
          }
        }
      }

      // 1px bugfix
      &.is-prev {
        .animation-box__wrapper {
          right: 1px;
        }
      }
    }

    .flex-container {
      display: flex;
      align-items: flex-end;
      position: absolute;
      bottom: $screen-gutter-bottom;
      left: $main-gutter-left;
      width: calc(100% - #{$main-gutter-left} - #{$screen-gutter-right});
    }
  }

  .line-dekor {
    height: 1px;
    flex: 1 0 75%;
    background-color: #000;
  }

  .hooper {
    height: 100%;
    &-liveregion {
      display: none;
    }
    &-slide {
      position: relative;
      display: flex;
      overflow: hidden;
      justify-content: flex-end;
      flex-direction: column;
      padding: $screen-gutter-top $screen-gutter-right $screen-gutter-bottom
        $main-gutter-left;
    }
  }

  .line-dekor {
    height: 1px;
    flex: 1 0 75%;
    background-color: #000;
  }

  .logo-text {
    position: absolute;
    top: 110px;
    left: calc(6% + 32px);
    z-index: 5;
  }

  .hooper {
    height: 100%;

    &-liveregion {
      display: none;
    }

    &-slide {
      position: relative;
      display: flex;
      overflow: hidden;
      justify-content: flex-end;
      flex-direction: column;
      padding: $screen-gutter-top $screen-gutter-right $screen-gutter-bottom
        $main-gutter-left;
    }
  }

  .animation-box {
    // background-image: url(../../assets/img/sprites/compressed/HP-01.png);
    // background-repeat: no-repeat;

    // loader on header sprite
    // &[lazy="loading"] {
    //   background-image: url(../../assets/img/loader-white.svg) !important;
    //   animation: none !important;
    //   background-size: 100px;
    //   background-position: center 6%;
    // }

    &__wrapper {
      position: absolute;
      top: 40%;
      right: 0;
      bottom: 0;
      width: 80%;
      height: 0;
      padding-bottom: 80%;
      transform: translate(0, -50%);
      z-index: -1;
    }

    &__image {
      // 1px bugfix
      &::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: 1px;
        bottom: 0;
        width: 3px;
        background-color: $primary-color;
        // background-color: red;
        z-index: 20;
      }
    }
  }

  .arrow {
    &__container {
      // display: none;
      flex: 1 1 90px;
      z-index: 1;
      transform: translateY(calc(50% - 1px));
    }

    &--left {
      margin-left: calc((100% - 24px) / 2);
      transform: translateX(-50%);
    }
  }

  .scroll-down {
    position: absolute;
    bottom: $screen-gutter-bottom;
    left: calc(100% - #{$main-width} - #{$aside-gutter-right});
    transform: translateX(-100%);
    transform-origin: center;

    &:hover {
      transform: translateX(-100%) rotate(30deg);
    }
  }

  @media (max-width: $tablet) {
    // .mobile-navbar {
    //   display: none;
    // }

    .main.main {
      justify-content: flex-start;
      padding-top: 26px;
      flex-grow: 1;

      .upper-title,
      .flex-container,
      .title {
        display: none;
      }

      .bottom-text {
        position: absolute;
        left: calc(6% + 32px);
        z-index: 2;
      }

      .animation-box {
        &__wrapper {
          top: 47%;
          bottom: unset;
          transform: translateY(-50%);
          width: 100%;
          padding-bottom: 100%;
          z-index: 1;
          right: 0% !important;
          overflow: hidden;
        }
      }
    }

    .scroll-down {
      right: 6%;
      left: unset;
      z-index: 10;
      transform: translateX(0);
    }
  }
}
</style>